import { Component, OnInit, Injector, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WorkOrdersService } from '../../work-orders.service';
import { BodyWorkOrderService } from '../../../ve.service';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { BodyDeliverablesDialogComponent } from '../dialogs/body-deliverables-dialog/body-deliverables-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

const VE_WORK_ORDER_ROUTE = '/VE/Work-Orders';

@Component({
  selector: 'body-wo-add-multiple',
  templateUrl: './body-wo-add-multiple.component.html',
  styleUrls: ['../body-wo-add/body-wo-add.component.scss', '../../work-orders.component.scss']
})
export class BodyWoAddMultipleComponent implements OnInit, OnDestroy {
  appCardTitle: string;
  router: Router;
  service: WorkOrdersService;
  bodyWorkOrderService: BodyWorkOrderService;
  cgpConfirmationDialogService: CgpConfirmationDialogService;
  cgpAlertDialogService: CgpAlertDialogService;
  matDialog: MatDialog;
  deliverables: any[];

  constructor(injector: Injector) {
    this.service = injector.get(WorkOrdersService);
    this.bodyWorkOrderService = injector.get(BodyWorkOrderService);
    this.cgpConfirmationDialogService = injector.get(CgpConfirmationDialogService);
    this.cgpAlertDialogService = injector.get(CgpAlertDialogService);
    this.appCardTitle = 'Add Multiple New Body Work Orders';
    this.router = injector.get(Router);
    this.matDialog = injector.get(MatDialog);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.service.resetForm();
    this.service.enableForm();
    this.service.resetGridView();
  }

  submit() {
    this.selectDeliverables();
  }

  private selectDeliverables() {
    const data = {
      title: 'Select Deliverables for Work Order Submission',
      yesLabel: 'Submit',
      noLabel: 'Cancel',
    };

    const dialogRef = this.matDialog.open(BodyDeliverablesDialogComponent, { data, width: '750px' });

    dialogRef.afterClosed()
      .subscribe(result => {
        this.deliverables = result;
        if (this.deliverables && this.deliverables.length > 0) {
          this.createBulkWorkOrders();
        }
      });
  }

  private createBulkWorkOrders() {
    const bodyWorkOrder = this.service.bodyAddMultipleForm.value;
    bodyWorkOrder.DeliverableIds = this.deliverables;
    this.bodyWorkOrderService.loading.next(true);

    this.bodyWorkOrderService
      .save(bodyWorkOrder, false, '/BulkCreate')
      .then(response => {
        this.bodyWorkOrderService.loading.next(false);

        if (response) {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Confirmation',
            message: `${response.length} Work Orders created successfully.`,
            alert: 'success',
            closeLabel: 'OK',
          });
        } else {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Error',
            message: 'Work Orders not created. Please try again.',
            alert: 'danger',
            closeLabel: 'OK',
          });
        }
        this.router.navigate([this.service.workOrderGridRouting[this.service.getWorkOrderGridType()]()]);
      });
  }

  public get isFormValid(): boolean {
    return this.service.bodyAddMultipleForm.valid;
  }

  back = (isCancel) => {
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: `Confirm ${isCancel ? 'Cancel' : 'Navigation'}`,
      message: `Are you sure you want to ${isCancel ? 'Cancel' : 'navigate away from this page'}? Your changes may be lost.`,
      alert: 'danger',
      onYesClick: () => {
        this.router.navigate([this.service.workOrderGridRouting[this.service.getWorkOrderGridType()]()]);
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }
}
